<template>
  <v-dialog width="800px" persistent v-model="agree">
    <template v-slot:activator="{ on }">
      <v-btn color="green" v-on="on" class="mr-2">
        <v-icon left>mdi-poll</v-icon>
        Rate the idea
      </v-btn>
    </template>
    <v-card>
      <v-container>
        <h3>Rating</h3>
        <v-rating
          class="ma-2"
          v-model="value"
          half-increments
          label="Rating"
          color="yellow darken-3"
        >
        </v-rating>
        <v-divider></v-divider>
        <h4 class="my-2">Please confirm your choice: you have given {{this.value}} stars for {{ item.name }}</h4>
        <h4 class="red--text my-2"><v-icon class="yellow--text text--darken-2" left>mdi-alert</v-icon>WARNING: you may not change your rating</h4>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            class="ma-4"
            @click="onRating"
          >
            <v-icon left>
              mdi-checkbox-marked-circle
            </v-icon>
            Confirm Rating
          </v-btn>
          <v-btn
            class="ma-2"
            color="grey"
            @click="agree=false"
          >
            <v-icon left>mdi-close</v-icon>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {
      agree: false,
      value: 3
    }
  },
  methods: {
    onRating () {
      const info = {
        name: this.item.name,
        description: this.item.description,
        type: this.item.type,
        time: this.item.time,
        date: this.item.date,
        rating: this.item.rating + this.value,
        id: this.item.id,
        voteCount: this.item.voteCount + 1
      }
      this.$store.dispatch('createVideoIdeaRating', info)
      this.agree = false
    }
  },
  computed: {
    items () {
      return this.$store.getter.loadedVideoIdeas(this.id)
    }
  }
}
</script>

<style>

</style>
